import React from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap';
import * as API from 'modules/app/API';

class Notification extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            isOpen: true,
            notificationList: []
        };
    }

    onClick = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    componentDidMount() {
        API.App.get('/query/getUserNotifications', null, {
            success: (r) => {
                this.setState({ notificationList: r.data.notifications });
            }
        });
    }

    render() {
        if (this.state.notificationList.length === 0)
            return null;

        const notificationList = this.state.notificationList.map((notification, key) => {
            let location = `/notifications`;

            return (
                <li key={key}><Link to={location}><Glyphicon glyph="asterisk" /> {notification.title}</Link></li>
            );
        });

        return (
            <React.Fragment>
                <a onClick={this.onClick} style={{ cursor: "pointer" }}>
                    <Glyphicon glyph="exclamation-sign" />
                    <span>Notifications</span>
                    <span className="pull-right">
                        <Glyphicon glyph={this.state.isOpen ? "chevron-down" : "chevron-right"} />
                    </span>
                </a>
                <ul className="treeview-menu" style={{ display: this.state.isOpen ? "block" : "none" }}>
                    {notificationList}
                </ul>
            </React.Fragment>
        );
    }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/layouts/main/sidebar/Notification.js